import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { waterfallAnalysesActions } from 'features/waterfallAnalyses';

const useWaterfallAnalyses = () => {
  const dispatch = useDispatch();
  const getWaterfallAnalyses = useCallback(({ offset }) => dispatch(waterfallAnalysesActions.getWaterfallAnalyses({ offset })), [dispatch]);
  const getWaterfallAnalysis = useCallback(({ id, cable }) => dispatch(waterfallAnalysesActions.getWaterfallAnalysis({ id, cable })), [dispatch]);
  const createWaterfallAnalysis = useCallback((waterfall_analysis) => dispatch(waterfallAnalysesActions.createWaterfallAnalysis(waterfall_analysis)), [dispatch]);
  const clearLocalWaterfallAnalyses = useCallback(() => dispatch(waterfallAnalysesActions.clearLocalWaterfallAnalyses()), [dispatch]);
  const clearLocalActiveWaterfallAnalysis = useCallback(() => dispatch(waterfallAnalysesActions.clearLocalActiveWaterfallAnalysis()), [dispatch]);

  return {
    getWaterfallAnalyses,
    getWaterfallAnalysis,
    createWaterfallAnalysis,
    clearLocalWaterfallAnalyses,
    clearLocalActiveWaterfallAnalysis
  };
};

export default useWaterfallAnalyses;